import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { ISortingValue } from 'search/services/search-params.service';
import { DropdownValue } from 'common/models/custom-dropdown';
import { Observable } from 'rxjs';

@Component({
  selector: 'search-res-sort',
  templateUrl: './search-res-sort.component.html',
  styleUrls: ['./search-res-sort.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResSortComponent {
  public expanded = false;
  @Input() public value: ISortingValue;
  @Input() public focus$: Observable<undefined>;
  @Output() public onChange: EventEmitter<DropdownValue<ISortingValue>> = new EventEmitter<{ selected: ISortingValue; label: string; }>();
  public SORTING_OPTIONS: Array<ISortingValue> = [
    {key: 'relevance:asc', sorting: 'relevance', sortOrder: 'asc'},
    {key: 'publicationDate:desc', sorting: 'publicationDate', sortOrder: 'desc'},
    {key: 'publicationDate:asc', sorting: 'publicationDate', sortOrder: 'asc'},
    {key: 'catalogDate:desc', sorting: 'catalogDate', sortOrder: 'desc'},
  ];

  public onDropdownChange(value: { selected: string; label: string; }) {
    this.value = this.SORTING_OPTIONS.find((item) => item.key === value.selected);
    this.onChange.emit({selected: this.value, label: value.label});
  }
}
